import vuetify from '@/main';
import MatterInfo from './MatterInfo.vue';

// `angular` is a runtime global set at app bootstrap (ProvidePlugin's `angular`
// entry is disabled), matching the other AngularJS registration files. Declared
// here only to satisfy TypeScript; it is erased at compile time.
declare const angular: any;

/**
 * Mounts the Vue <MatterInfo> component inside an Angular template.
 *
 * Used to swap the Angular matter Info tab (read view + edit directive) for the
 * Vue implementation in-place, gated by the `internConversion` feature flag.
 * The Angular templates keep the old markup behind `ng-if` so both paths stay
 * available while the flag is rolled out.
 *
 * Reuses the shared `vuetify()` bridge helper (see src/main/main.js) which wires
 * the shared Pinia instance, Vuetify, Sentry, and — importantly — unmounts the
 * Vue app on `$destroy` so navigating between matters doesn't leak state.
 * Props (stateParams, state, rootScope, alerts, matterTagsService) are provided
 * by iocContainer.
 *
 * NOTE: this file is a `.ts` module, so it is NOT picked up by the
 * `require.context(..., /\.js$/)` auto-loader in app.js. It is imported
 * explicitly from clients.routes.js so the directive gets registered.
 */
angular.module('leanlaw').directive('llMatterInfoVue', [
  () => ({
    restrict: 'E',
    ...vuetify(MatterInfo),
  }),
]);
